import styled from 'styled-components/native';

// flex: 1 causes view to expand to fit parent
export const SafeAreaViewExpand = styled.SafeAreaView`
  flex: 1;
`;

// flex: 1 causes view to expand to fit parent
export const ViewExpand = styled.View`
  flex: 1;
`;

export const SafeAreaViewCentered = styled.SafeAreaView`
  flex: 1;
  justify-content: center;
  align-items: center;
`;

export const ViewCentered = styled.View`
  flex: 1;
  justify-content: center;
  align-items: center;
`;
